module.exports = __webpack_public_path__ + "img/logo_name.661c955c.png";